// componnet
import CustomButton from "../../kits/custom-button/CustomButton";
import { TrashIcon } from "../../kits/Icons/Icons";
import { ArrowDownIcon } from "../../kits/Icons/Icons";
import DeleteCartItemDrawer from "./DeleteCartItemDrawer";
import imgsabadi from "../../../assets/images/defaultCover/defaultCoverProduct.png";
import ShoppingCartItemContext from "../../../context/ShoppingCart/ShoppingCartItemContext";
import { pathMaker } from "../../../utilities/helperFunctions";
import useWindowSize from "../../../hooks/useWindowSize";
import Drawer from "../../drawer/Drawer";
import useAxios from "../../../services/useAxios";
import DrawerTxtBtn from "../DrawerTxtBtn";
import Image from "../Image";
// react imports
import { useState, useContext, useMemo, useEffect } from "react";
import { addCommas } from "@persian-tools/persian-tools";
import { NavLink, useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card"; // style
import "./BasketItems.scss";
export default function BasketItems({
  // checkInventoryFun,
  supplierinfo,
  items,
  index,
  val,
  user_Address,
  updateShoppingList,
}) {
  const { execute: checkInventory } = useAxios("api/check_inventory");
  const navigate = useNavigate();
  let inventory = 0;
  let specialProducts = [],
    moreProducts = [];
  let indFor = "";

  for (let index = 0; index < items.length; index++) {
    if (index < 3) {
      specialProducts.push(items[index]);
      indFor = index;
    } else {
      indFor = index;
      moreProducts.push(items[index]);
    }
  }
  console.log("888", val);
  const [totalInventory, setTotalInventory] = useState();
  const { width } = useWindowSize();
  const [activKey, setActivKey] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  console.log("inv", totalInventory);

  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [isOpenMinOrderDrawer, setIsOpenMinOrderDrawer] = useState(false);

  // fun
  async function checkInventoryFun(supplier_id) {
    await checkInventory({
      supplier_id: supplier_id,
    }).then((res) => {
      if (res.status == 1) {
        setTotalInventory(res.cartItems);
        cheched(res.cartItems);
      }
    });
  }
  const cheched = (inventory) => {
    if (!inventory) return undefined;
    if (inventory.length === 0) {
      if (getTotalPrice() >= supplierinfo.min_order_amount) {
        navigate(`/check-out/${supplierinfo.suppliers__id}`);
      } else {
        setIsOpenMinOrderDrawer(true);
      }
    } else if (inventory.length > 0) {
      setIsOpenDrawer(true);
      updateShoppingList();
    }
  };

  console.log("0000", parseInt(supplierinfo.min_order_amount));
  const drawerWidth = useMemo(() => {
    return width < 422 ? 178 : width >= 442 ? 165 : 165;
  }, [width]);

  // amountAfterDiscount
  const amountAfterDiscount = (price, discount) => {
    let amount = "";
    amount = parseInt(price - discount);
    return amount;
  };

  // totalPrice
  const getTotalPrice = () => {
    let number = 0;
    for (let index = 0; index < items?.length; index++) {
      number += parseInt(
        (items[index].apo_info.price - items[index].apo_info.discount) *
          items[index].current_count
      );
    }
    return number;
  };
  console.log("getTotalPrice", getTotalPrice());
  return (
    <div className="p-basketItems">
      <div className="d-flex pd-r-20 pd-l-24 mr-t-20">
        <div className=" d-flex box-info">
          <NavLink to={`/shop/${supplierinfo.suppliers__id}`}>
            <div className="p-img">
              <Image
                src={pathMaker(supplierinfo.path)}
                style={{
                  width: "72px",
                  height: "72px",
                  borderRadius: "6px",
                }}
              ></Image>
              {/* {supplierinfo.path ? (
                <img
                  src={pathMaker(supplierinfo.path)}
                  style={{
                    width: "72px",
                    height: "72px",
                    borderRadius: "6px",
                  }}
                ></img>
              ) : (
                <img
                  src={imgsabadi}
                  style={{
                    width: "72px",
                    height: "72px",
                    borderRadius: "6px",
                  }}
                ></img>
              )} */}
            </div>
          </NavLink>

          <div className="d-flex-column mr-r-12 mr-y-8">
            <NavLink
              to={`/shop/${supplierinfo.suppliers__id}`}
              className="text-decoration-none color-nav"
            >
              <div className="title-h4-m name-store">{supplierinfo.title} </div>
            </NavLink>
            <div className="mr-t-12">
              <span className="desc-l">تحویل به:</span>
              <span className="desc-c-l "> {user_Address[0]?.title} </span>
            </div>
          </div>
        </div>

        <div
          className="box-trash mr-r-20"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <TrashIcon width="24px" height="24px"></TrashIcon>
        </div>
        <div>
          <DeleteCartItemDrawer
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            supplierId={supplierinfo.suppliers__id}
          />
        </div>
      </div>
      <div className="d-flex-colomn pd-x-20 mr-t-8 product-container">
        {specialProducts.map((val, ind) => {
          // console.log("activekey", activKey);
          // console.log("indFor", indFor);

          return (
            <>
              <div className="d-flex product-item" key={`basket_item_${ind}`}>
                <div className="p-img2">
                  <Image
                    src={pathMaker(val.product_info.path)}
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "6px",
                    }}
                  ></Image>
                </div>
                <div className="d-flex-column mr-r-12 w-100">
                  <div className="title-h5-m title-item">
                    {val.product_info.title}
                  </div>
                  <div className="d-flex mr-t-4 align-item-center box-items justify-content-between w-100    ">
                    <div className="desc-l">{val.current_count}&nbsp; عدد</div>
                    <div className="desc-m">
                      {addCommas(
                        amountAfterDiscount(
                          val.apo_info.price,
                          val.apo_info.discount
                        )
                      )}
                      تومان
                    </div>
                  </div>
                </div>
                {activKey != `active${indFor}` &&
                items.length > 2 &&
                ind == 2 ? (
                  <div className="box-gradient"> </div>
                ) : (
                  ""
                )}
              </div>
              {/* {ind < specialProducts.length - 1 && ( */}
              {open == true ? (
                <div className="line mr-y-8"></div>
              ) : (
                ind < specialProducts.length - 1 &&
                open == false && <div className="line mr-y-8"></div>
              )}
              {/* <div className="line mr-y-8"></div> */}
              {/* // )} */}
            </>
          );
        })}

        <Accordion
          onSelect={(e) => {
            setActivKey(e);
          }}
        >
          <Card>
            <Accordion.Collapse eventKey={`active${indFor}`}>
              <Card.Body>
                {moreProducts?.map((val, ind) => {
                  return (
                    <>
                      <div
                        className="d-flex product-item"
                        key={`basket_item_${ind}`}
                      >
                        <div className="p-img2">
                          <Image
                            src={pathMaker(val.product_info.path)}
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "6px",
                            }}
                          ></Image>
                        </div>
                        <div className="d-flex-column mr-r-12 w-100">
                          <div className="title-h5-m title-item">
                            {val.product_info.title}
                          </div>
                          <div className="d-flex mr-t-4 align-item-center box-items justify-content-between w-100    ">
                            <div className="desc-l">
                              {val.current_count}&nbsp; عدد
                            </div>
                            <div className="desc-m">
                              {addCommas(val.apo_info.price)} تومان
                            </div>
                          </div>
                        </div>
                      </div>
                      {ind < moreProducts.length - 1 && (
                        <div className="line mr-y-8"></div>
                      )}
                    </>
                  );
                })}
              </Card.Body>
            </Accordion.Collapse>
            <Card.Header>
              {items.length > 2 && (
                <CustomToggle
                  eventKey={`active${indFor}`}
                  activeKey={activKey}
                  index={index}
                  supplierinfo={supplierinfo}
                  open={open}
                  setOpen={setOpen}
                ></CustomToggle>
              )}
            </Card.Header>
          </Card>
        </Accordion>
        {/* {inventory == 0 ? ( */}
        <div
          className="d-flex mr-t-8   mr-b-16 justify-content-center"
          // onClick={(e) => {
          //   setIsOpenDrawer(true);
          // }}
        >
          <CustomButton
            className="pd-x-16 w-50 w-100 pd-y-12"
            buttonStyle="secondary"
            state="default"
            size="large"
            onClick={() => {
              // console.log("checkInventoryFun", supplierinfo.suppliers__id);
              checkInventoryFun(supplierinfo.suppliers__id);
            }}
          >
            <span className="title-h4-m " style={{ textAlign: "center" }}>
              تکمیل خرید{" "}
            </span>
          </CustomButton>
        </div>
        {/* // ) : ( */}
        {/* <NavLink
          to={`/check-out/${supplierinfo.suppliers__id}`}
          className="text-decoration-none"
        >
          <div
            className="d-flex mr-t-8   mr-b-16 justify-content-center"
            onClick={(e) => {
              setIsOpenDrawer(true);
            }}
          >
            <CustomButton
              className="pd-x-16 w-50 w-100 pd-y-12"
              buttonStyle="secondary"
              state="default"
              size="large"
              // onClick={() => {
              //   setIsOpen(false);
              // }}
            >
              <span className="title-h4-m " style={{ textAlign: "center" }}>
                تکمیل خرید{" "}
              </span>
            </CustomButton>
          </div>
        </NavLink> */}
        {/* // )} */}
      </div>
      {index < val.length - 1 && <div className="line mr-t-32"></div>}

      {/* drawer inventory */}
      <Drawer
        isOpen={isOpenDrawer}
        onClose={() => setIsOpenDrawer(false)}
        height={drawerWidth}
      >
        <div className="pd-x-20 parent-drawer">
          <div className="demo-content">
            <div className="title mr-t-16 desc-c-l">
              موجودی «
              {totalInventory?.map((val, ind) => {
                return `${val.product_title}${
                  ind < totalInventory.length - 1 ? " - " : ""
                } `;
              })}
              » تمام شده و از سبد خرید شما حذف شده است.
            </div>
            <div className="mr-t-40 ">
              <div className="d-flex justify-content-between mr-t-20">
                <CustomButton
                  onClick={(e) => {
                    if (getTotalPrice() >= supplierinfo.min_order_amount) {
                      navigate(`/check-out/${supplierinfo.suppliers__id}`);
                    } else {
                      setIsOpenMinOrderDrawer(true);
                      setIsOpenDrawer(false);
                    }
                    console.log("if getTotalPrice", getTotalPrice());
                    console.log(
                      "if supplierinfo.suppliers__id",
                      supplierinfo.min_order_amount
                    );
                  }}
                  className="btn-yes txt-t1-m"
                  buttonType="primary"
                  size="medium"
                >
                  پرداخت
                </CustomButton>

                <NavLink
                  to={`/shop/${supplierinfo.suppliers__id}`}
                  className="text-decoration-none color-nav"
                >
                  <CustomButton
                    buttonStyle="text"
                    size="large"
                    className="btn-no txt-t1-m"
                    type="button"
                  >
                    منو سوپرمارکت
                  </CustomButton>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
      {/* drawer min order amount */}
      <DrawerTxtBtn
        isOpen={isOpenMinOrderDrawer}
        setIsOpen={setIsOpenMinOrderDrawer}
        height={135}
        mainText="مجموع مبلغ سفارش از حداقل سفارش این فروشگاه کمتر است"
        btnText="منو سوپر مارکت"
        to={`shop/${supplierinfo.suppliers__id}`}
      ></DrawerTxtBtn>
    </div>
  );
}
function CustomToggle({ eventKey, activeKey, index, open, setOpen }) {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    console.log("totally custom!")
  );

  return (
    <button
      style={{
        width: "99px",
        marginRight: "auto",
        marginLeft: "auto",
        height: "48px",
      }}
      className={`accordion-button collapsed1 ${
        activeKey != eventKey && "btn-position"
      }`}
      type="button"
      data-bs-toggle="collapse"
      onClick={decoratedOnClick}
      aria-expanded="true"
    >
      <div className="d-flex mr-r-auto mr-l-auto">
        {activeKey == eventKey ? (
          <div
            className="d-flex"
            onClick={(e) => {
              setOpen(false);
            }}
          >
            <div className="title-h4-m">بستن</div>

            <div className="mr-r-6">
              <ArrowDownIcon
                width="24px"
                height="24px"
                iconClassName="tranformIcon"
              ></ArrowDownIcon>
            </div>
          </div>
        ) : (
          <div
            className="d-flex"
            onClick={(e) => {
              setOpen(true);
            }}
          >
            <div
              className="title-h4-m"
              // onClick={(e) => {
              //   setOpen(true);
              // }}
            >
              بیشتر
            </div>

            <div className="mr-r-6">
              <ArrowDownIcon width="24px" height="24px"></ArrowDownIcon>
            </div>
          </div>
        )}
      </div>
    </button>
  );
}
//  if (!inventory.length === 0) {
//         setIsOpenDrawer(true);
//         console.log("!===");
//       } else if (getTotalPrice() < parseInt(supplierinfo.min_order_amount)) {
//         setIsOpenMinOrderDrawer(true);
//         console.log("<=");
//       }
